import moment from "moment";

export const CompareDates = (dateTimeA, dateTimeB) => {
    if (dateTimeA > dateTimeB) return 1;
    else if (dateTimeA < dateTimeB) return -1;
    else return 0;
}

export const DateDiff = (dateTimeA, dateTimeB) => {
    var tiempo1 = dateTimeA.getTime();
    var tiempo2 = dateTimeB.getTime();

    var diferencia = tiempo2 - tiempo1;

    var diferenciaDias = diferencia / (10000 * 360 * 24);

    return diferenciaDias;
}

export const deepEqualObj = (obj1, obj2) => {
    const keys1 = Object.keys(obj1 || {});
    const keys2 = Object.keys(obj2 || {});

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }

    return true;
}
export const getLastYearsList = (numOfYears = 1, order = 'DESC') => {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let i = 0; i < numOfYears; i++) {
        years.push(currentYear - i);
    }

    if (order === 'ASC') {
        years.reverse();
    }

    return years;
}


export const calcularDiferenciaHoras = (fechaIngreso, fechaEgreso) => {
    // Si faltan las fechas, devolver cadena vacía
    if (!fechaIngreso || !fechaEgreso) return "";

    // Crear momentos a partir de datetimes (acepta Date u ISO/string)
    const ingreso = moment(fechaIngreso);
    const egreso = moment(fechaEgreso);

    // Validar momentos
    if (!ingreso.isValid() || !egreso.isValid()) return "";

    // Si la fecha de egreso es anterior a la de ingreso, no tiene sentido calcular -> devolver ""
    if (egreso.isBefore(ingreso)) return "";

    // Calcular duración total
    const duracion = moment.duration(egreso.diff(ingreso));
    const horas = Math.floor(duracion.asHours());
    const minutos = duracion.minutes();

    return `${horas.toString().padStart(2, "0")}:${minutos.toString().padStart(2, "0")}`;
}